import { useQuery } from 'react-query';

import type { IContact } from 'src/services/api/contacts/types';
import { apiClient } from 'src/services/api/client';
import { queryKeys } from 'src/services/api/constants';
import { CONTACTS_PATH } from 'src/services/api/contacts/constants';

export type IGetContactsResponse = {
    contacts: Array<Omit<IContact, 'property_ids'> & {
        property_ids?: number[];
    }>;
};

export const useContacts = () => {
    return useQuery(
        [queryKeys.contacts],
        async () => {
            const res = await apiClient(CONTACTS_PATH).json<IGetContactsResponse>();
            // property_ids is normalized here so consumers can rely on it being present
            return res.contacts.map<IContact>((contact) => ({
                ...contact,
                property_ids: contact.property_ids ?? [],
            }));
        }
    );
};
